import React from 'react';

function Marq2() {
  const renderItem = (key) => (
    <div key={key} className="item">
      <h4 className="d-flex align-items-center">
        <span>Onde Ideias nascem e&nbsp;</span>
        <span className="main-color">marcas crescem.</span>
        <span className="icon-img-50 ml-30">
          <img src="/assets/imgs/isotipo-light.png" alt="" />
        </span>
      </h4>
    </div>
  );

  const renderBox = (prefix) => (
    <div className="box">
      {Array.from({ length: 4 }).map((_, i) => renderItem(`${prefix}-${i}`))}
    </div>
  );

  return (
    <section className="call-marq section-padding o-hidden">
      <div className="main-marq lrg sub-bg pt-20 pb-20">
        <div className="slide-har st1">
          {renderBox('a')}
          {renderBox('b')}
        </div>
      </div>
      <div className="main-marq bord-item">
        <div className="slide-har st2">
          {renderBox('c')}
          {renderBox('d')}
        </div>
      </div>
    </section>
  );
}

export default Marq2;
